<template>
    <DForm>
        <DFormRow
            :label="__('settings.herold_location_settings.form.api_url')"
            :is-required="true"
            :error="errorsData.api_url"
            :hint="__('settings.herold_location_settings.form.api_url_hint')"
        >
            <DInput
                id="herold_location_api_url"
                v-model="form.api_url"
                :placeholder="__('settings.herold_location_settings.form.api_url')"
                type="url"
                :is-valid="isFormFieldValid('api_url')"
                maxlength="255"
                @update:value="valueUpdated"
            />
        </DFormRow>
        <DRow>
            <DCol sm="4" />
            <DCol sm="4">
                <div
                    v-if="connectionStatus === 'successful'"
                    class="green-text"
                >
                    {{ __('settings.connections.connection_successful') }}
                </div>
                <div
                    v-if="connectionStatus === 'unsuccessful'"
                    class="red-text"
                >
                    {{ __('settings.connections.connection_unsuccessful') }}
                </div>
            </DCol>
            <DCol
                sm="4"
                class="check-database-connection-btn"
            >
                <DButton
                    icon="lan-connect"
                    :label="__('settings.connections.check_connection')"
                    :disabled="isInLoadingState"
                    @click="checkConnection()"
                />
            </DCol>
        </DRow>
        <DFormControls
            :dirty="form.isDirty"
            :disabled="connectionStatus !== 'successful'"
            @submit="submitForm()"
        />
        <DConnectionErrorModal
            :show-modal="connectionException !== null"
            :exception="connectionException"
            @close-modal="closeModal"
        />
    </DForm>
</template>

<script setup>
import { ref, onUpdated } from 'vue'
import { route } from '~@/Composables/route'
import { useForm } from '@inertiajs/vue3'

import DConnectionErrorModal from '~@/Components/Common/DConnectionErrorModal'

const props = defineProps({
    heroldLocationSettings: {
        type: Object,
        default: () => { return {} }
    },
    errors: {
        type: Object,
        default: () => { return {} }
    }
})

const form = useForm({
    api_url: props.heroldLocationSettings?.api_url
})

const emit = defineEmits(['submit-form'])

const connectionStatus = ref('')
const errorsData = ref(props.errors)
const connectionException = ref(null)

onUpdated(() => {
    errorsData.value = props.errors
})

const checkConnection = () => {
    errorsData.value = {}
    connectionException.value = null

    window.axios.post(route('settings.herold-location-settings.check', form))
        .then(function () {
            connectionStatus.value = 'successful'
        })
        .catch(function (error) {
            connectionStatus.value = 'unsuccessful'

            if (error.response.data.exception !== undefined) {
                connectionException.value = error.response.data.exception
            }

            if (error.response.data.errors !== undefined) {
                errorsData.value = error.response.data.errors

                for (const key in errorsData.value) {
                    if (typeof errorsData.value[key] === 'object') {
                        errorsData.value[key] = errorsData.value[key][0]
                    }
                }
            }
        })
}

const submitForm = () => {
    emit('submit-form', form)
}

const valueUpdated = () => {
    connectionStatus.value = null
}

function closeModal () {
    connectionException.value = null
}
</script>

<style scoped lang="scss">
    .check-database-connection-btn {
        text-align: right;
        padding-bottom: 12px;
    }
    .green-text {
        color: green;
    }
    .red-text {
        color: red;
    }
</style>
